import React from 'react';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import RainIconBlue from '../../../images/wind-icons/Rain-Icon-Blue.svg';
import RainIcon from '../../../images/wind-icons/Rain-Icon-Grey.svg';

const MobileTab = (props) => {

  const weatherImages = require.context('../../../images/weather-icons/', true);
  const windImages = require.context('../../../images/wind-icons/', true);
  let weatherIcon =  weatherImages('./blank.svg');
  if (typeof(props.day.dayIcon) != "undefined")
    weatherIcon =  weatherImages('./'+props.day.dayIcon);

  let current = "weathergridsmall"
  if(props.current===true)
    current = "weathergrid";

    var windSpeed = props.day.windSpeed;
    let maxTemp = props.day.maxTemp;
    let minTemp = props.day.minTemp;
    let rain = Math.max(props.day.rainProbMorning, props.day.rainProbAfternoon)
    if (props.Evening)
      rain = props.day.rainProbEvening

    if (props.windMode === "Miles") {
      windSpeed = props.day.windSpeedMPH;
    }
  
    if (props.windMode === "Kilometres") {
      windSpeed = props.day.windSpeedKM;
    }
  
    if (props.windMode === "Knots") {
      windSpeed = props.day.windSpeedKnots;
    }
  
    if (props.tempMode !== "Celsius") {
      maxTemp = props.day.maxTempFahrenheit;
      minTemp = props.day.minTempFahrenheit;
    }

    let windIcon =  windImages('./blank.svg');
  
  if (typeof(props.day.windDirection) != "undefined")
    windIcon =  windImages('./'+props.day.windDirection+'.svg');
    

  return (

    <React.Fragment>
    <div className={current}>
        <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} style={{fontSize:"16px", marginTop:"5px", marginBottom:"10px"}}>
          {props.day.dayName}
        </Grid>
      </Grid>

      <Grid container alignItems="center">
        <Grid item xs={6} sm={6} md={6} lg={6}>
        <Tooltip title={props.day.dayToolTip} aria-label={props.day.dayToolTip}>
        <img style={{maxWidth:"60px"}} className="weatherIconTab" src={weatherIcon.default} alt="sunnyCloud"/>
        </Tooltip>
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6}>
          <div style={{fontSize:"16px", fontWeight:"700"}} >{props.Evening ? minTemp : maxTemp}</div>
        </Grid>
        </Grid>
        <Grid container alignItems="center">
        <Grid item xs={6} sm={6} md={6} lg={6}>
        <div className="windTab">

            <img style={{maxWidth:"50px"}} className="windIconMainTab" src={windIcon.default} alt="" />
              
              {props.windMode === "Miles" && 
            <Tooltip title={props.day.windToolTipMPH} aria-label={props.day.windToolTipMPH}>
            <div className="windSpeedTab">{windSpeed}</div>
            </Tooltip>}

            {props.windMode === "Kilometres" && 
            <Tooltip title={props.day.windToolTipKM} aria-label={props.day.windToolTipKM}>
            <div className="windSpeedTab">{windSpeed}</div>
            </Tooltip>}

            {props.windMode === "Knots" && 
            <Tooltip title={props.day.windToolTipKnots} aria-label={props.day.windToolTipKnots}>
            <div className="windSpeedTab">{windSpeed}</div>
            </Tooltip>}

            {props.windMode !== "Knots" && props.windMode !== "Kilometres" && props.windMode !== "Miles" &&
            <Tooltip title={props.day.windToolTip} aria-label={props.day.windToolTip}>
            <div className="windSpeedTab">{windSpeed}</div>
            </Tooltip>}
            </div>      
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={6}>
        <div style={{color:"#1d1d1b", fontWeight:"normal"}}>
        {rain}%<br />
            <Tooltip title="Rain" aria-label="Rain">
            { rain > 19 ? <img style={{maxWidth:"50px"}} className="rainIcon" src={RainIconBlue} alt=""/> : <img className="rainIcon" src={RainIcon} alt=""/> }
            </Tooltip>
        </div>
 
  
        </Grid>
        </Grid>
        </div>
    </React.Fragment>
  )
}

export default MobileTab
